import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';

import { classificatorTranslatedArray, i18, i18clGroups, required } from '../../../../../utilities';
import { ButtonGroup, ButtonWrapper, FormField, formFieldType, Translate } from '../../../../../components';

export const PartnerJobSourcesForm = (props) => {
    return (
        <Form
            onSubmit={props.submit}
            initialValues={props.data}
            render={({ handleSubmit }) => (
                <form
                    onSubmit={handleSubmit}
                    autoComplete='off'
                >
                    <FormField
                        inline
                        title={i18.PartnerJobSourcesForm.Labels.JobSources}
                        name='jobSources'
                        component={formFieldType.multiSelect}
                        options={classificatorTranslatedArray(i18clGroups.CLIENT_SEGMENTS)}
                        validate={required}
                        disabled={props.submitting}
                    />
                    <div className='text-right'>
                        <ButtonGroup>
                            <ButtonWrapper
                                type='text'
                                disabled={props.submitting}
                                onClick={() => props.cancel()}
                            >
                                <Translate value={i18.PartnerJobSourcesForm.Buttons.Cancel} />
                            </ButtonWrapper>
                            <ButtonWrapper
                                type='primary'
                                htmlType='submit'
                                loading={props.submitting}
                            >
                                <Translate value={i18.PartnerJobSourcesForm.Buttons.Submit} />
                            </ButtonWrapper>
                        </ButtonGroup>
                    </div>
                </form>
            )}
        />
    );
};

PartnerJobSourcesForm.propTypes = {
    cancel: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};
